import React from "react";
import { Award, Shield, FileCheck, TrendingUp } from "lucide-react";

const CertificationsSection = () => {
  return (
    <section id="certifications" className="section-padding bg-white reveal">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-12">
            <span className="text-[#8B1538] font-semibold text-sm uppercase tracking-wider">Trust & Compliance</span>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
              Certifications & Standards
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              Committed to maintaining the highest standards of quality, safety, and regulatory compliance.
            </p>
          </div>

          {/* Certifications Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-12">
            <div className="bg-gradient-to-br from-red-50 to-white rounded-xl shadow-lg border border-red-100 p-8">
              <div className="flex items-center space-x-4 mb-4">
                <div className="bg-white p-2 rounded-lg shadow-md">
                  <img src="/quality-logo.png" alt="ISO 9001:2015" className="h-16 w-auto" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">ISO 9001:2015</h3>
                  <p className="text-sm text-gray-600">Quality Management System</p>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Internationally recognized certification ensuring consistent quality in our manufacturing processes and product delivery.
              </p>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-white rounded-xl shadow-lg border border-red-100 p-8">
              <div className="flex items-center space-x-4 mb-4">
                <div className="bg-[#8B1538] p-3 rounded-lg">
                  <FileCheck className="h-8 w-8 text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">GST Registered</h3>
                  <p className="text-sm text-gray-600">Government Compliance</p>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Fully compliant with Indian tax regulations and all statutory requirements.
              </p>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-white rounded-xl shadow-lg border border-red-100 p-8">
              <div className="flex items-center space-x-4 mb-4">
                <div className="bg-[#8B1538] p-3 rounded-lg">
                  <Shield className="h-8 w-8 text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">International Standards</h3>
                  <p className="text-sm text-gray-600">Export Compliance</p>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Our products meet international quality and safety standards for export markets including China and Singapore.
              </p>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-white rounded-xl shadow-lg border border-red-100 p-8">
              <div className="flex items-center space-x-4 mb-4">
                <div className="bg-[#8B1538] p-3 rounded-lg">
                  <TrendingUp className="h-8 w-8 text-white" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900">Environmental Commitment</h3>
                  <p className="text-sm text-gray-600">Sustainability Focus</p>
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Low VOC emissions and eco-friendly formulations aligned with global environmental standards.
              </p>
            </div>
          </div>

          {/* Dealership CTA */}
          <div className="bg-gradient-to-r from-[#8B1538] to-[#DC143C] rounded-2xl p-8 lg:p-12 text-white text-center shadow-2xl">
            <h3 className="text-3xl font-bold mb-4">Dealership Opportunities Available</h3>
            <p className="text-xl opacity-90 mb-6 max-w-2xl mx-auto">
              Looking for authorized dealers across India. Join our growing network and represent a trusted brand in printing solutions.
            </p>
            <button
              onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
              className="bg-white text-[#8B1538] hover:bg-gray-100 px-8 py-4 rounded-md font-semibold text-lg transition-colors"
            >
              Become a Dealer
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;
